var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.switchModal)?_c('div',[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.uri}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }